<template>
    <div>
        <div class="modal hide fade" id="modalBstkDetail" tabindex="-1" role="dialog" aria-labelledby="modalBstkDetail" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Bastk Serial Number</h4>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <table class="table table-sm table-item table-striped">
                            <thead>
                                <th style="width: 40%">Product</th>
                                <th style="width: 10%">Qty</th>
                                <th style="width: 10%">UoM</th>
                                <th style="width: 30%">Serial</th>
                                <th>#</th>
                            </thead>
                            <tbody>
                                <tr v-for="d in salesDeliver" :key="d.id">
                                    <td>[{{ d.product_no }}] {{ d.product }}</td>
                                    <td>
                                        <input type="text" v-model="d.qty" v-if="detail.canBarcode === false">
                                        <input type="text" v-model="d.qty" v-else disabled="disabled">
                                    </td>
                                    <td>{{ d.uom_id }}</td>
                                    <td>
                                        <input type="text" v-model="d.serial_number" v-if="detail.canBarcode === false" disabled="disabled">
                                        <input type="text" v-model="d.serial_number" v-else>
                                    </td>
                                    <td>
                                        <button type=" button" class="btn btn-danger btn-sm" @click="remove(d.id)"><i class="fa fa-trash"></i></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a href="#" @click="addDeliver('no')">Add Line</a>
                                    </td>
                                    <td colspan="4"></td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <pre>{{ detail }}</pre> -->
                        <!-- <pre>{{ salesDeliver }}</pre> -->
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-danger btn-sm pull-left" data-dismiss="modal"><i class="fa fa-times"></i> Cancel</button>
                      <button type="button" class="btn btn-primary btn-sm pull-right" data-dismiss="modal" @click="saveBarcode"><i class="fa fa-save"></i> Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, inventoryUrl, salesUrl } from '../../config'
// import Axios from 'axios'
export default {
  name: 'SalesBstkDetail',
  props: ['sales', 'detail'],
  created () {
    // Add barcode scan listener and pass the callback function
    console.log('created barcode init')
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  computed: {
    salesDeliver: function () {
      if (this.sales.delivers) {
        return this.sales.delivers.filter(d => d.id !== null).filter(d => d.product_no === this.detail.product_no)
      } else {
        return []
      }
    },
    getTotalQty: function () {
      var sum = 0
      var array = this.salesDeliver
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty)
      }
      return sum
    }
  },
  methods: {
    remove: function (id) {
      var detail = this.sales.delivers.find(d => d.id === id)
      var index = this.sales.delivers.findIndex(d => d.id === id)
      if (detail.state === 'create') {
        this.sales.delivers.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          console.log(result)
          if (result.value) {
            Axios.delete(salesUrl + '/deliver/' + detail.id, { headers: getHeader() })
              .then(response => {
                console.log(response.data.data)
                this.sales.delivers.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    onBarcodeScanned: function (barcode) {
      console.log(barcode)
      var obj = {
        barcode: barcode,
        product_no: this.detail.product_no
      }
      Axios.post(inventoryUrl + '/serial-number', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.addDeliver(response.data.data.serial_number)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            'Cannot GET Serial Number',
            'error'
          )
        })
    },
    saveBarcode: function () {
      var data = {
        qty_done: this.getTotalQty,
        idPDetail: this.detail.id
      }
      this.$emit('saveBarcodeProduct', data)
    },
    cancelBarcode: function () {
      console.log('cancel Barcode')
    },
    addDeliver: function (sn) {
      if (this.salesDeliver.length < this.detail.qty) {
        let newSn = null
        if (sn !== 'no') {
          newSn = sn
        } else {
          newSn = null
        }
        var newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
        var obj = {
          id: newID,
          sale_no: this.sales.sales_no,
          serial_number: newSn,
          qty: 1,
          product_no: this.detail.product_no,
          product: this.detail.products.product_name,
          branch_no: this.sales.branch_no,
          warehouse_no: null,
          uom_id: this.detail.uom_id,
          state: 'create'
        }
        if (this.detail.products.canBarcode === false) {
          if (this.sales.delivers.length > 0) {
            this.sales.delivers.push(obj)
          }
        } else {
          this.sales.delivers.push(obj)
        }
      }
    }
  }
}
</script>
